import React from "react";
import ReactECharts from 'echarts-for-react';
const option = {
    title: {
        text: 'Top Cards by View',
        subtext: '',
        left: 'center',
        textStyle: {
            fontSize: 14, 
            fontWeight: 'normal', 
            color: '#2E2E30' 
        }
    },
   
    legend: {
        left: 'center',
        top: 'bottom',
        data: ['Feroz', 'Cardiast', 'Arish'],
        padding: 15,
    },
    
    series: [
        {
            name: 'chart',
            type: 'pie',
            radius: [60, 100],
            roseType: '',
            data: [
                {value: 10, name: 'Feroz', itemStyle: { color: '#056CF2' }},
                {value: 5, name: 'Cardiast', itemStyle: { color: '#FF9900' }},
                {value: 15, name: 'Arish', itemStyle: { color: '#95C3FF' }},
            ]
        }
    ]
};

const TopCardView = () => {
    return (
        <div className="top-card-chart">
            <ReactECharts opts={{renderer: 'svg'}} option={option} lazyUpdate={true} />
        </div>
    );
}

export default TopCardView;